/* file description */

import { useCallback, useRef, useState } from 'react';
import { Modal } from 'antd';
import { COLUMN_FROM } from '../../../effects/consts';
import { getModuleRecordList } from '@/common/asset-apis/assetModel'
import { OnLinkShowModalTableSelect, OnRecordSelectLinkShowModalEnter, SetShowFieldsValue, UseLinShowModalSelect } from './type';

export const useLinShowModalSelect: UseLinShowModalSelect = ({ setShowLabel, API, isMulti, setOptionList }) => {
  // 弹窗展示控制
  const [showLinkShowModal, linkShowModalContrulor] = useState(false);
  // 选中控制
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  // selected选择控制
  const SelectedRef = useRef<Record<any, any> | null>(null);
  // 选择后的回调处理
  const onSelectChange = useCallback<OnLinkShowModalTableSelect>(
    (_selectedIDList: React.Key[], selectedRecordList: Array<Record<any, any>>) => {
      setSelectedRowKeys(_selectedIDList)
      if (isMulti) {
        SelectedRef.current = selectedRecordList || null;
      } else {
        SelectedRef.current = selectedRecordList[0] || null;
      }
    },
    [SelectedRef.current],
  );
  
  // 单击行时处理
  const clickRow = (key: any, record: any) => {
    if (isMulti) {
      const keysList = [...selectedRowKeys]
      if (keysList.indexOf(key) >= 0) {
        keysList.splice(keysList.indexOf(key), 1)
      } else {
        keysList.push(key)
      }
      setSelectedRowKeys(keysList)
    } else {
      SelectedRef.current = record
      setSelectedRowKeys([key])
    }
  }
  
  // 联动字段更新
  const setShowFieldsValue:SetShowFieldsValue = (form, field, columnFrom, config, type) => {
    if (isMulti) {
      return
    }
    const { showFields = [], options = [] } = field.options || {};
    options.forEach((item: { moduleField: any; linkField: any }) => {
      const values: Record<any,any> = {}
      if (columnFrom === COLUMN_FROM.FORM) {
        values[item.moduleField] = type === 'reset' ? '' : SelectedRef.current![item.linkField]
        form.setFieldsValue(values)
      }
      if (columnFrom === COLUMN_FROM.TABLE) {
        const tableKey = config.rowIndex
        values[tableKey] = {}
        values[tableKey][item.moduleField] = type === 'reset' ? '' : SelectedRef.current![item.linkField]
        form.setFieldsValue(values)
      }
    })
  }

  const setInputLabel = async (field: any, initLabel: string, initValue: string) => {
    const option: Record<any,any> = {}
    option[field?.options?.label] = initLabel || initValue
    option[field?.options?.value] = initValue
    setOptionList([option])
  }

  // 弹窗确认按钮被点击后的处理
  const onModalEnter = useCallback<OnRecordSelectLinkShowModalEnter>(({ onChange, fieldName, form, field, columnFrom, config }) => {
    if (!SelectedRef.current) {
      Modal.confirm({
        content: '您未选择任何一项，这将会将其设为空，确认此操作吗?',
        onOk: () => {
          // TODO 联动更新
          setShowFieldsValue(form, field, columnFrom, config, 'reset')
          onChange && onChange(null);
          // setShowLabel('')
          linkShowModalContrulor(false);
        },
      });
      return;
    }
    if (isMulti) {
      const multiArr: any[] = []
      const multiLabel: any[] = []
      SelectedRef.current.forEach((item: Record<string, any>) => {
        multiArr.push(item[fieldName])
        multiLabel.push(item[field?.options?.label] || item[field?.options?.value])
      })
      setOptionList(SelectedRef.current)
      onChange && onChange(multiArr);
      // setShowLabel(multiLabel.join())
    } else{
      if (field?.options?.isBindLabel) {
        setInputLabel(field, SelectedRef.current[fieldName], SelectedRef.current[fieldName])
      } else {
        setOptionList([SelectedRef.current])
      }
      // 选择时给联动字段赋值
      setShowFieldsValue(form, field, columnFrom, config)
      onChange && onChange(SelectedRef.current[fieldName]);
    }
    linkShowModalContrulor(false);
  }, []);

  return {
    showLinkShowModal,
    onSelectChange,
    onModalEnter,
    linkShowModalContrulor,
    setInputLabel,
    clickRow,
    selectedRowKeys,
  };
};
